import Rover from '@rover/globals/Rover';
import { appendUrlParams, getUrlParameter } from './url';
import { getCookie } from './cookie';
import inject from './injector';

export const getRouteURL = (deeplink = 'rover://campaign/') => {
  const shouldIncludeMobileNativePushParam = inject(
    'Rover.context.shouldIncludeMobileNativePushParam',
    false
  );

  if (Rover.deeplink) {
    deeplink = Rover.deeplink;
  }

  // append Mobile Native Push UTM Params
  if (shouldIncludeMobileNativePushParam) {
    Rover.UTMParameters = {
      utm_source: 'app_install_banner',
      utm_medium: 'web',
      utm_campaign: 'quick_match_landing_20180102',
    };
  }

  // append utm parameters if they exist
  if (Rover.UTMParameters) {
    deeplink = appendUrlParams(deeplink, Rover.UTMParameters);
  }

  if (Rover.firstHttpReferrer) {
    deeplink = appendUrlParams(deeplink, {
      http_referrer: encodeURIComponent(Rover.firstHttpReferrer),
    });
  }

  // append Ambassador params if they exist
  const ambassadorMbsyCode = getUrlParameter('mbsy');
  if (ambassadorMbsyCode) {
    const campaignId = getUrlParameter('campaignid');
    deeplink = appendUrlParams(deeplink, {
      mbsy: ambassadorMbsyCode,
      campaignid: campaignId,
    });
  }

  // append rover_cid
  const roverCid = getCookie('rover_cid');
  if (roverCid) {
    deeplink = appendUrlParams(deeplink, { rover_cid: roverCid });
  }

  // Deeplink needs the protocol removed
  const afterClickUrl = encodeURIComponent(window.location.href);
  const deeplinkPath = encodeURIComponent(deeplink.split('rover://')[1]);
  const routeURL = appendUrlParams(
    `https://r.rover.com/a/${Rover.context.branchKey}`,
    { $deeplink_path: deeplinkPath, $after_click_url: afterClickUrl }
  );

  return routeURL;
};



// WEBPACK FOOTER //
// ../utilities/deeplink.js